import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/AntDesign/unicodesMap.json';
export default createIconSet(glyphMap, 'AntDesign', require('~/../assets/fonts/AntDesign/AntDesign.ttf'));
